var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "arrow-left_svg__nc-icon-wrapper",
    strokeWidth: 1.2,
    fill: "none",
    stroke: "#AFAFAF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M15.5 8.5H.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.5l-5 5 5 5"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGcgY2xhc3M9Im5jLWljb24td3JhcHBlciIgc3Ryb2tlLXdpZHRoPSIxLjIiIGZpbGw9IiNhZmFmYWYiIHN0cm9rZT0iI0FGQUZBRiI+PGxpbmUgZmlsbD0ibm9uZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHgxPSIxNS41IiB5MT0iOC41IiB4Mj0iMC41IiB5Mj0iOC41IiBkYXRhLWNvbG9yPSJjb2xvci0yIi8+IDxwb2x5bGluZSBmaWxsPSJub25lIiBzdHJva2U9IiNBRkFGQUYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBwb2ludHM9IjUuNSwzLjUgMC41LDguNSA1LjUsMTMuNSAiLz48L2c+PC9zdmc+";
export { SvgArrowLeft as ReactComponent };